import React from 'react';
import PropTypes from 'prop-types';
import { Card, Typography, Tooltip } from 'components/alf-design';
import { METHOD } from 'utils/constants';

import PolicyCancelled from './PolicyCancelled';
import BillingContent from './BillingContent';

const Billing = ({
  policy,
  policyFusionNH,
  handleHistoryClick,
  handleMakePaymentClick,
  loading,
}) => {
  const { agent, status, billing } = policy || {};

  let tooltip = 'To update your payment plan, please contact your agent.';
  if (billing && billing.autoPay) {
    switch (billing.collectionMethod) {
      case METHOD.CARD:
      case METHOD.PENDING_CARD:
        tooltip =
          'To update your payment plan or pay with your bank, please contact your agent.';
        break;
      case METHOD.BANK:
      case METHOD.PENDING_BANK:
        tooltip =
          'To update your payment plan or pay with your card, please contact your agent.';
        break;
      default:
        tooltip = 'To update your payment plan, please contact your agent.';
        break;
    }
  }

  let premium = 0;
  let sameStatus = false;
  let isFusionCancelled = false;
  if (policy?.isFusion) {
    if (policy?.status === policyFusionNH?.status) {
      sameStatus = true;
      premium = (policy?.price ?? 0) + (policyFusionNH?.price ?? 0);
    } else if (
      policy?.status !== 'Cancelled' &&
      policyFusionNH?.status === 'Cancelled'
    ) {
      premium = policy?.price ?? 0;
    } else if (
      policy?.status === 'Cancelled' &&
      policyFusionNH?.status !== 'Cancelled'
    ) {
      premium = policyFusionNH?.price ?? 0;
    } else if (
      ['Cancelled', 'Inactive'].includes(policy.status) &&
      ['Cancelled', 'Inactive'].includes(policyFusionNH.status)
    ) {
      isFusionCancelled = true;
    }
  }

  if (
    (policy?.isFusion && isFusionCancelled) ||
    status === 'Cancelled' ||
    status === 'Inactive'
  ) {
    return (
      <PolicyCancelled
        agent={agent}
        handleHistoryClick={handleHistoryClick}
        status={status.toLowerCase()}
      />
    );
  }

  return (
    <Card className="billing">
      <Typography type="h2" component="h2" className="mb-[24px]">
        Billing
        {billing && billing.autoPay && (
          <Tooltip ariaLabel="Billing Card Tooltip" text={tooltip} />
        )}
      </Typography>
      {billing === null && (
        <div className="bg-legacy-errorBackground border border-legacy-errorBorder p-[13px] rounded-[8px]">
          <Typography type="error">Something went wrong.</Typography>
          <Typography type="error">
            If you need immediate assistance, please contact Customer Service at{' '}
            <a href="tel:8007482030" className="text-legacy-primary">
              (800) 748-2030
            </a>
            .
          </Typography>
        </div>
      )}
      {billing && (
        <BillingContent
          agent={agent || {}}
          billing={billing}
          premium={premium}
          sameStatus={sameStatus}
          handleHistoryClick={handleHistoryClick}
          handleMakePaymentClick={handleMakePaymentClick}
          loading={loading}
        />
      )}
    </Card>
  );
};
Billing.propTypes = {
  policy: PropTypes.object,
  handleHistoryClick: PropTypes.func,
  handleMakePaymentClick: PropTypes.func,
};

export default Billing;
